import { Service } from '@/tools'
export class procureRequireService<T extends TProcure.Require> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.Require}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 人工备货列表
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)
  // 人工备货删除
  delete = <K extends T['ApiDelete']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDelete', data)
  // 人工备货新增
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)
  // 人工备货详情
  info = <K extends T['ApiInfo']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiInfo', data)
  // 人工备货详情-商品明细
  detail = <K extends T['ApiDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDetail', data)
  // 人工备货更新
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data)
  // 人工备货 - 删除采购需求单明细
  deleteDetail = <K extends T['ApiDeleteDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteDetail', data)

  // 分批查询采购需求列表-按订单展示 /api/procure/require/v1/pageOrder
  pageOrder = <K extends T['ApiPageOrder']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageOrder', data)
  // 采购需求单-订单维度
  end = <K extends T['ApiEnd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiEnd', data)
  // 采购需求单-采购需求-明细了结
  endDetail = <K extends T['ApiEndDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiEndDetail', data)
  // 采购信息确认-商品统计
  confirmGroup = <K extends T['ApiConfirmGroup']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiConfirmGroup', data)

  // 采购信息确认-前置校验
  addPreAllocationRecord = <K extends T['ApiAddPreAllocationRecord']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddPreAllocationRecord', data)
  // 采购信息确认-商品统计-本次采购规划
  confirmGroupRefresh = <K extends T['ApiConfirmGroupRefresh']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiConfirmGroupRefresh', data)
  // 采购信息确认-商品统计-查询可用库存
  confirmStock = <K extends T['ApiConfirmStock']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiConfirmStock', data)
  // 采购信息确认-商品统计-查询订单明细
  confirmInfo = <K extends T['ApiConfirmInfo']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiConfirmInfo', data)
  // 采购信息确认-商品统计-查询订单明细-确认
  confirmStockAllocate = <K extends T['ApiConfirmStockAllocate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiConfirmStockAllocate', data)
  // 采购信息确认-拆分采购订单
  confirmSplit = <K extends T['ApiConfirmSplit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiConfirmSplit', data)
  // 采购需求单详情
  cgInfo = <K extends T['ApiCgInfo']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiInfo', data)
  // 采购需求单详情-商品明细
  cgDetail = <K extends T['ApiCgDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDetail', data)
  // 采购需求单-更新需求单明细信息
  updateDetail = <K extends T['ApiUpdateDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateDetail', data)
  // 查看需求单订单明细-按商品信息查询
  detailByCommodity = <K extends T['ApiDetailByCommodity']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDetailByCommodity', data)

  // 分页查询采购需求单列表（批量）
  pageInfoByIds = <K extends T['ApiPageInfoByIds']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageInfoByIds', data)

  //查询转移数据
  selectTransfer = <K extends T['ApiSelectTransfer']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSelectTransfer', data)

  //导入商品明细（页面导入）  /api/procure/require/v1/importDetail
  importDetail = <K extends T['ApiImportDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiImportDetail', data)

  //人工备货-手动寻源  /api/procure/require/v1/manualSourcing
  manualSourcing = <K extends T['ApiManualSourcing']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiManualSourcing', data, '操作成功')
}
